import { render, staticRenderFns } from "./upload-certificate-modal.vue?vue&type=template&id=44fd4e07&scoped=true"
import script from "./upload-certificate-modal.vue?vue&type=script&lang=js"
export * from "./upload-certificate-modal.vue?vue&type=script&lang=js"
import style0 from "./upload-certificate-modal.vue?vue&type=style&index=0&id=44fd4e07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fd4e07",
  null
  
)

export default component.exports